<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import Icon from '@/components/Icon.vue'
import { useFloor } from '@/stores/floor'
import { useNotify } from '@/stores/notify'

const route = useRoute()
const floor = useFloor()
const notify = useNotify()

const TITLES: Record<string, [string, string]> = {
  floor: ['The Floor', 'where everyone is, at a glance'],
  mentions: ['Mentions', 'where you were @-mentioned'],
  calendar: ['Calendar', 'the team’s heartbeat'],
  memory: ['Memory', 'the office that never forgets'],
  settings: ['Settings', 'make Atrium yours'],
}

const title = computed<[string, string]>(() => {
  if (route.name === 'room') {
    const r = floor.roomBySlug(String(route.params.slug))
    return [r?.name || 'Room', 'a place on the floor']
  }
  return TITLES[String(route.name)] || ['Atrium', '']
})

const clock = ref('--:--')
let timer: ReturnType<typeof setInterval> | null = null
function tick() {
  const d = new Date()
  clock.value = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}
onMounted(() => { tick(); timer = setInterval(tick, 10000) })
onUnmounted(() => { if (timer) clearInterval(timer) })
</script>

<template>
  <header class="topbar">
    <div class="topbar__title">
      <h2>{{ title[0] }}</h2>
      <span class="topbar__sub txt-lo">{{ title[1] }}</span>
    </div>
    <div class="topbar__right">
      <span class="clock mono">{{ clock }}</span>
      <button class="top-toggle inbox-bell" :class="{ 'has-unread': notify.inboxUnread }" data-tip="Inbox" @click="notify.toggle()">
        <Icon name="bell" :size="18" />
        <span v-if="notify.inboxUnread" class="bell-badge">{{ notify.inboxUnread > 9 ? '9+' : notify.inboxUnread }}</span>
      </button>
    </div>
  </header>
</template>
